import Route from '@ember/routing/route';
import type { CostModel } from 'lumen/routes/market/settings/cost';

export default class MarketSettingsCostIndexRoute extends Route {
  model(): CostModel {
    return this.modelFor('market.settings.cost') as CostModel;
  }
}
